import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosConfig from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

export const useToggleBot = (
  options?: UseMutationOptions<any, Error>,
  withoutToast?: boolean
) => {
  return useMutation({
    mutationKey: ["toggleBot"],
    mutationFn: async () => {
      return axiosConfig.post(`/controls/toggle`).then((res) => res.data);
    },
    onMutate: (variables) => {
      if (!withoutToast) {
        Toast({
          message: "Ładowanie...",
          type: TOAST_TYPES_ENUM.LOADING,
          id: "toggleBot",
        });
      }
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      if (!withoutToast) {
        Toast({
          message: "Pomyślnie aktywowano/dezaktywowano bota",
          type: TOAST_TYPES_ENUM.SUCCESS,
          id: "toggleBot",
        });
      }
      queryClient.invalidateQueries({ queryKey: ["controls"] });

      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },

    onError: (error, variables, context) => {
      if (!withoutToast) {
        Toast({
          message: "Błąd podczas aktywacji/dezaktywacji bota",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "toggleBot",
        });
      }
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
